import { render, staticRenderFns } from "./fourDiagnostic.vue?vue&type=template&id=35492c0a&scoped=true&"
import script from "./fourDiagnostic.vue?vue&type=script&lang=ts&"
export * from "./fourDiagnostic.vue?vue&type=script&lang=ts&"
import style0 from "./fourDiagnostic.vue?vue&type=style&index=0&id=35492c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35492c0a",
  null
  
)

export default component.exports